const validateCNPJ = val => {
  val = val.replace(/[^\d]+/g, "");

  // Elimina CNPJs inválidos conhecidos
  if (val == "" || val.length != 14 || /^(.)\1+$/.test(val)) return false;

  // Valida DVs
  let tamanho = val.length - 2;
  let numeros = val.substring(0, tamanho);
  let digitos = val.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = val.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
};

export default validateCNPJ;



// WEBPACK FOOTER //
// ./src/components/Validators/CNPJ.js